<template>
  <div class="hubday-section">
    <div class="hubday-head">
      <i class="material-icons-outlined">view_day</i>Emploi du temps
    </div>
    <div class="hubday-body planning">
      <h2>
        <div id="date">
          <transition :name="transition" mode="out-in">
            <div v-html="dateText" v-bind:key="dateText">{{ dateText }}</div>
          </transition>
          <transition :name="transition" mode="out-in">
            <div class="smaller" v-bind:key="month">
              {{ month }}
              <transition name="fade" mode="out-in">
                <i class="material-icons-outlined" v-bind:key="presence">{{ presence }}</i>
              </transition>
            </div>
          </transition>
        </div>
        <div class="controls">
          <button v-on:click="updatePlanning(-1)" class="round-left">
            <i class="material-icons">chevron_left</i>
          </button>
          <button v-on:click="initialize()" class="no-round">
            <i class="material-icons">home</i>
          </button>
          <button v-on:click="updatePlanning(1)" class="round-right">
            <i class="material-icons">chevron_right</i>
          </button>
        </div>
      </h2>
      <transition :name="transition" mode="out-in">
        <div v-if="planning == null" class="day"></div>
        <div v-else-if="planning.length > 0" class="planningDay" v-bind:key="planning[0]['uid']">
          <div
            class="slot z-depth-1 hoverable"
            v-for="slot in planning"
            v-bind:key="slot.id"
            :style="{ borderLeft: '8px solid' + moduleColor(slot['module'])}"
          >
            <div
              class="hour"
              :style="{ color: moduleColor(slot['module']) }"
            >
              {{ slot["start"].split(":").slice(0, -1).join(":") }} - {{ slot["end"].split(":").slice(0, -1).join(":") }}
              <span
                v-if="slot['type']"
                class="timer"
                :style="{ backgroundColor: pSBC(0.5, moduleColor(slot['module']))}"
              >
                <!--<i class="material-icons-outlined">alarm</i>-->
                {{ (slot["type"] ? slot["type"].split('_')[0] : "") }}
              </span>
            </div>
            <div class="module" v-if="slot['module'] != 'Matière à préciser'">
              {{ slot["module"] }}
              <div v-if="slot['subtitle']" class="subtitle" v-html="createTextLinks(slot.subtitle)"></div>
            </div>
            <div class="module" v-else-if="slot['subtitle']" v-html="createTextLinks(slot.subtitle)"></div>
            <div class="module" v-else>Module inconnu</div>
            <div class="infos">
              <div class="location" v-if="slot['rooms'] !== undefined">
                <i class="material-icons-outlined">meeting_room</i>
                {{ slot["rooms"].join(', ') }}
              </div>
              <div v-else class="location"></div>
              <div class="prof" v-if="slot['teachers'] !== undefined">
                {{ slot["teachers"].join(', ') }}
                <i class="material-icons-outlined">emoji_people</i>
              </div>
              <div class="prof" v-else></div>
            </div>
          </div>
        </div>
        <div v-else class="day">
          <transition name="fade" mode="out-in">
            <div class="noItem" v-bind:key="presence">
              <i
                class="material-icons-outlined"
              >{{ presence == "beach_access" ? getWeekNumber(date) > 51 ? "ac_unit" : "deck" : "self_improvement" }}</i>
              {{ presence == "beach_access" ? "Bonnes vacances !": "Pas de cours ce jour là" }}
            </div>
          </transition>
        </div>
      </transition>
    </div>
    <transition name="fade" mode="out-in">
      <div class="hubday-footer" v-bind:key="lastUpdate">{{ lastUpdate }}</div>
    </transition>
  </div>
</template>

<style>
#date .smaller i {
  vertical-align: bottom;
}

.hubday-body h2 {
  margin: 0;
  display: flex;
  justify-content: space-between;
  line-height: 90%;
  min-height: 42px;
  margin-bottom: 6px;
}

.dashboard .hubday-body .controls button {
  border: none;
  cursor: pointer;
  height: 36px;
  margin: 0 2px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  background-color: #ddd;
  transition: background-color 0.3s;
  font-size: 24px;
  line-height: 40px;
  padding: 0 4px;
  line-height: 44px;
}

.dashboard .hubday-body.planning .controls button {
  padding: 0;
}

.dashboard .hubday-body .controls button.round-left {
  border-radius: 8px 0 0 8px;
}

.dashboard .hubday-body .controls button.no-round {
  border-radius: 0;
}

.dashboard .hubday-body .controls button.round-right {
  border-radius: 0 8px 8px 0;
}

.dashboard .hubday-body .controls button:hover {
  background-color: #ccc;
}

.dashboard .hubday-body .controls button i {
  font-size: 28px;
}

.smaller {
  font-size: 16px;
  color: #888;
}
</style>

<style>
.planningDay {
  /*min-height: 430px;*/
  display: flex;
  flex-direction: column;
  height: 125%;
  /*max-height: 510px;*/
}

.day {
  display: flex;
  flex-direction: column;
}

.day .noItem {
  min-height: 430px;
}

.slot {
  flex: 1;
  min-height: 100px;
  max-height: 140px;
  border-radius: 8px;
  margin: 5px 0;
  border-left: 8px solid #3498db;
  padding: 6px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  font-size: 16px;
}

.planning-container .hubday-section {
  height: 100%;
  max-height: 664px;
}

.planning-container .hubday-body {
  max-height: 600px;
}

.slot:first-child {
  margin-top: 0;
}

.slot:last-child {
  margin-bottom: 0;
}

.slot .hour {
  font-weight: bold;
  color: #3498db;
}

.slot .timer {
  float: right;
  font-size: smaller;
  background-color: #ddd;
  padding: 2px 6px;
  border-radius: 10px;
}

.slot .timer i {
  font-size: 15px;
  vertical-align: text-bottom;
}

.slot .module {
  font-weight: bold;
}

.slot .subtitle {
  font-weight: normal;
  font-size: 14px;
}

.slot .location,
.slot .prof {
  font-size: smaller;
  color: #444;
}

.slot .location i.material-icons-outlined,
.slot .prof i.material-icons-outlined {
  color: #444;
  font-size: 18px;
  vertical-align: -25%;
}

.slot .infos {
  display: flex;
  justify-content: space-between;
}
</style>

<script>
import M from "materialize-css";
import { mapState } from "vuex";

import * as firebase from "firebase/app";
import "firebase/database";
const rtdb = firebase.database();
var lastUpdateRef = rtdb.ref("planning/infos/lastCheck");

export default {
  data() {
    return {
      date: null,
      dateText: null,
      month: null,
      transition: "fade",
      planning: null,
      lastUpdate: null,
      presence: "",
      presenceWeeksHoliday: [44, 52, 53, 7, 16],
      presenceWeeksPrime: [37, 39, 41, 43, 46, 48, 50, 1, 3],
      presenceWeeksSeconde: [38, 40, 42, 45, 47, 49, 51, 2],
    };
  },
  methods: {
    textDate(inputFormat) {
      var jours = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ];
      var mois = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];

      var d = new Date(inputFormat);
      return [
        jours[d.getDay()],
        d.getDate() == 1 ? d.getDate() + "<sup>er</sup>" : d.getDate(),
        mois[d.getMonth()],
        this.pad(d.getFullYear()),
      ];
    },
    pad(s) {
      return s < 10 ? "0" + s : s;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    sort_by_key(array, key) {
      if (array == null) return [];

      return array
        .sort(function (a, b) {
          var x = a[key];
          var y = b[key];
          return x < y ? -1 : x > y ? 1 : 0;
        })
        .filter(
          (e) => !e["options"] || (this.userProfile !== undefined && this.userProfile["options"].filter(function(o) { return e.options.indexOf(o) !== -1; }).length > 0)
        );
    },
    updatePlanning(step) {
      this.transition = step < 0 ? "previous" : step > 0 ? "next" : "fade";
      this.date.setDate(this.date.getDate() + step);

      if (this.date.getDay() == 0) {
        this.date.setDate(this.date.getDate() + step);
      }

      if (this.date.toJSON() <= new Date("2020-09-06").toJSON()) {
        this.date = new Date("2020-09-07");
        M.toast({ html: "Impossible de reculer plus !" });
      } else if (this.date.toJSON() >= new Date("2021-07-01").toJSON()) {
        this.date = new Date("2021-06-30");
        M.toast({ html: "Impossible d'avancer plus !" });
      }

      var events = [];

      var path = this.userProfile["group1"] + (this.userProfile["subgroup1"] != "" ? "-" + this.userProfile["subgroup1"] : "")
      if (this.date.toJSON() > new Date("2021-01-24").toJSON()) path = this.userProfile["group2"] + (this.userProfile["subgroup2"] != "" ? "-" + this.userProfile["subgroup2"] : "")
      // régler l'erreur à la deconnexion

      var groupRef = this.planningRef.child(path).child(this.formatDate(this.date));
      var self = this;
      groupRef.on("value", function (snapshot) {
        events.push.apply(events, snapshot.val());
        self.planning = self.sort_by_key(events, "start");
        self.dateText = self.textDate(self.date).slice(0, 2).join(" ");
        self.month = self.textDate(self.date)[2];
        self.presence =
          (self.presenceWeeksPrime.includes(self.getWeekNumber(self.date)) &&
            self.userProfile.subgroup1 == "prime") ||
          (self.presenceWeeksSeconde.includes(self.getWeekNumber(self.date)) &&
            self.userProfile.subgroup1 == "seconde")
            ? "business"
            : self.presenceWeeksHoliday.includes(self.getWeekNumber(self.date))
            ? "beach_access"
            : "home";
      });
    },
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = (d) => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    },
    getWeekNumber(dt) {
      var tdt = new Date(dt.valueOf());
      var dayn = (dt.getDay() + 6) % 7;
      tdt.setDate(tdt.getDate() - dayn + 3);
      var firstThursday = tdt.valueOf();
      tdt.setMonth(0, 1);
      if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7));
      }
      return 1 + Math.ceil((firstThursday - tdt) / 604800000);
    },
    initialize() {
      this.date = new Date();
      var timepassed = this.date.getHours() * 60 + this.date.getMinutes();
      if (this.date.getDay() == 0) {
        this.date.setDate(this.date.getDate() + 1);
      } else if (timepassed > 1110) {
        // Si il est 18h30 passé
        this.date.setDate(this.date.getDate() + 1);
        if (this.date.getDay() == 0) {
          this.date.setDate(this.date.getDate() + 1);
        }
      }
      if (this.date.toJSON() <= new Date("2020-09-06 23:59:59").toJSON())
        this.date = new Date("2020-09-07");
      if (this.planningRef != null) this.updatePlanning(0);
    },
    createTextLinks(text) {
      return (text || "").replace(
        /([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi,
        function (match, space, url) {
          var hyperlink = url;
          if (!hyperlink.match("^https?://")) {
            hyperlink = "http://" + hyperlink;
          }
          return space + '<a href="' + hyperlink + '" target="_blank">(Lien)</a>';
        }
      );
    },
    moduleColor(moduleName) {
      if (Object.keys(this.modulesByAlias).includes(moduleName)) {
        return this.modules[this.modulesByAlias[moduleName]].color
      } else {
        return '#7f8c8d'
      }
    },
    moduleIcon(moduleName) {
      if (Object.keys(this.modulesByAlias).includes(moduleName)) {
        return this.modules[this.modulesByAlias[moduleName]].icon
      } else {
        return 'default'
      }
    }
  },
  computed: {
    ...mapState(["userProfile", "modules", "modulesByAlias", "planningRef"]),
  },
  watch: {
    planningRef() {
      this.updatePlanning(0);
    },
  },
  mounted() {
    var self = this;
    lastUpdateRef.on("value", function (snapshot) {
      var date = new Date(snapshot.val());
      self.lastUpdate =
        "Dernière mise à jour à " +
        self.pad(date.getHours()) +
        ":" +
        self.pad(date.getMinutes());
    });

    this.initialize();
  },
};
</script>